jQuery(document).ready(function () {

  // Restaurant Halong 2026-10-09 (H-D): globaler Schrittzähler (currentStep) entfernt. Er lief über alle Fenster
  // hinweg mit, so dass ein zweites Wok-Fenster bei Schritt 2 startete oder zwei Schritte gleichzeitig zeigte.
  // Weiter/Zurück regeln unten die Handler je Schritt (.closest('.step')); halongFensterStart setzt beim Öffnen zurück.
  
$('.confirmWok').on('click', function (e) {
    e.preventDefault();
    var button = $(this);
    const productId = $(this).data('product-id');
    const productVariantId = $(this).data('variant-id');
    const productTitle = $(this).data('product-title');
    var targetedPopupClass = `popup-${productId}`;    
    var selectedQty = $(`#addOnQty${productId}`).val();
    var selectedSauce = $('.activePopup .SaucesBox input:checked').data('title');
    var selectedSideDish = $('.activePopup .SideDishBox input:checked').data('title');
    // Collect all selected add-ons
    const selectedItems = [];
    let addonNames = [];

   var addonSKU = '';
   var freePremeal = '';
    $(`#addonForm-${productId} input:checked`).each(function () {
        const addonId = $(this).val();
        const addonName = $(this).data('title');
        const addonPrice = $(this).data('sell');
        addonSKU = ($(this).data('product-sku')) ? $(this).data('product-sku') : addonSKU;
        // Restaurant Halong 2026-10-08: gewählte Vorspeise übernehmen. data-free-premeal steht bei Suppe UND Salat auf
        // "Pekingsuppe"; der Bon zeigte deshalb Pekingsuppe, obwohl Salat gewählt war.
        freePremeal = ($(this).data('free-premeal')) ? $(this).data('title') : freePremeal; 

      // console.log(addonSKU)
        
        if (addonPrice) {
            selectedItems.push({
                id: addonId,
                quantity: selectedQty,
                properties: { 'Beilage für': productTitle + ', ' + selectedSauce }
            });
        }
      
      if(addonNames == ''){ 
         addonNames.push(addonName);
      }else{
        if(!freePremeal){
           addonNames.push(', '+addonName);
        }
      }
          // console.log(addonName)
    });
  
   if(selectedSauce && selectedSideDish){
     console.log(selectedSauce + selectedSideDish)
      if(selectedItems.length > 0){ 
        // Restaurant Halong 2026-10-08: Gericht und Beilage in EINEM Aufruf (ganz oder gar nicht),
        // verknüpft über die versteckte Kennung _Gruppe. Abgleich im Warenkorb: halong-beilage.js.
        // Kennung aus Gericht, Soße und Beilage berechnet (nicht zufällig): Gleiche Auswahl ergibt dieselbe Kennung,
        // Shopify fasst die Zeilen zu einer Menge zusammen (Bon #2291 zeigte zweimal 1× statt 2×). Karim 08.10.
        var halongKennung = function (s) { var h = 2166136261; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return (h >>> 0).toString(36); };
        var gruppe = 'w' + halongKennung(JSON.stringify([productVariantId, addonNames, freePremeal, addonSKU, selectedItems.map(function (i) { return [i.id, i.properties]; })]));
        // Beilagen als Liste wie vor dem 08.10. (print.php fügt Listen zu "Soße , Beilage" zusammen; Text mit ["…"] landete roh auf dem Bon).
        var items = selectedItems.map(function (item) {
          return { id: item.id, quantity: Number(selectedQty) || 1, properties: Object.assign({}, item.properties, { _Gruppe: gruppe }) };
        });
        // _Beilage SKU: im Checkout unsichtbar, print.php liest beide Namen (10.10.)
        items.push({
          id: productVariantId,
          quantity: Number(selectedQty) || 1,
          properties: { 'Beilagen': addonNames, 'Gratis Vorspeise': freePremeal, '_Beilage SKU': addonSKU, _Gruppe: gruppe }
        });
        button.text('Hinzufügen...');
        $('body').css('pointer-events','none');
        fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) return res.json().catch(function () { return {}; }).then(function (err) { throw new Error(err.description || ('HTTP ' + res.status)); });
            return res.json();
          })
          .then(function () {
            $('.activePopup .step').removeClass('active');
            $('.activePopup .addonRow.step').addClass('active');
            $('.productBlock input[type="radio"]').prop('checked', false);
            halongWokVorwahl();
            return window.halongNachHinzufuegen(targetedPopupClass);
          })
          .catch(function (error) { (window.halongHinzufuegenFehlgeschlagen || function (e) { console.warn('Wok konnte nicht hinzugefügt werden:', e); })(error); })
          .finally(function () {
            button.html(button.data('orig-html'));
            $('body').css('pointer-events', 'all');
          });
      }else{ 

          $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                  id: productVariantId,
                  quantity: selectedQty,
                  properties: {
                    'Beilagen': addonNames,
                    'Gratis Vorspeise': freePremeal,
                    // Restaurant Halong 2026-10-10: mit Unterstrich, damit der Checkout die Küchen-SKU nicht zeigt (print.php liest beide Namen)
                    '_Beilage SKU': addonSKU
                  }
                },
                dataType: 'json',
                beforeSend: function() {
                     button.text('Hinzufügen...');
                    $('body').css('pointer-events','none');
                  },
                success: function () {
                  $('.activePopup .step').removeClass('active');
                  $('.activePopup .addonRow').addClass('active');
                  $('.productBlock input[type="radio"]').prop('checked', false);
                  halongWokVorwahl();
                  button.html(button.data('orig-html'));
                  $('body').css('pointer-events', 'all');
                  window.halongNachHinzufuegen(targetedPopupClass);
                },
                error: function (xhr, status, error) {
                  // Restaurant Halong 2026-10-09: Knopf und Klickbarkeit auch im Fehlerfall zurücksetzen
                  // (vorher blieb die Seite nach einem 422 mit pointer-events:none gesperrt).
                  button.html(button.data('orig-html'));
                  $('body').css('pointer-events', 'all');
                  (window.halongHinzufuegenFehlgeschlagen || function (e) { console.warn('Wok konnte nicht hinzugefügt werden:', e); })((xhr && xhr.responseJSON && xhr.responseJSON.description) || error || status);
                },
              });

      }

     
    } else {
     
      // Restaurant Halong 2026-10-09 (H-D): Hinweis im Fenster statt Browser-Dialog.
      window.halongPflichtHinweis(this, window.halongFehlendeWahl(this) || 'Bitte triff eine Auswahl.');
     
    }
 
   
});

$(document).on('click', function (e) {
    // Ensure the popup is open
    if ($('.activePopup').length && !$(e.target).closest('.popup-inner, .popupOpener, .halong-add, .halong-bestseller__item').length) {
        $('.popup-close').click();
    }
});

$(document).on('click', '.popup-inner', function (e) {
    e.stopPropagation();
});



// Restaurant Halong 2026-10-08 (Nachbesserung UI-Prüfung, Befunde B1/H4): ein Preis für den Knopf, immer aus
// Grundpreis + gewählter Beilage (Gratis-Beilage = 0) × Menge. Vorher wurde der Preis nur bei Aufpreis-Beilagen
// neu gesetzt: Eiernudeln (+3 €) und zurück auf Jasminreis ließ 20,50 € stehen, der Warenkorb rechnete 17,50 €.
function halongEuro(s) { return parseFloat(String(s || '').replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.')) || 0; }
function halongWokPreis($popup) {
  $popup = $popup && $popup.length ? $popup : $('.activePopup');
  $popup.find('.confirmWok').each(function () {
    var $btn = $(this);
    var basis = $btn.data('basis-preis');
    // R-011 (2026-10-09): Aufpreis aus allen Schritten. Je nach Gericht liegt die Beilage in addon_02 oder addon_03
    // (Mittags-Woks: addon_02); vorher zählte nur addon_03, bei 14 von 25 Woks fehlte der Aufpreis auf dem Knopf.
    var aufpreis = 0;
    $popup.find('input[name^="addon_"]:checked').each(function () {
      if (String($(this).attr('data-sell')) === 'true') aufpreis += halongEuro($(this).attr('data-price'));
    });
    var menge = parseInt($popup.find('.addOnQty').val(), 10) || 1;
    $btn.find('.confirmPrice').text(((basis + aufpreis) * menge).toFixed(2).replace('.', ',') + ' €');
  });
}
// Gratis-Beilage vorwählen, wenn es genau eine gibt (Jasminreis o. ä.); Aufpreis bleibt bewusste Wahl.
function halongWokVorwahl() {
  $('.SideDishBox').each(function () {
    var $frei = $(this).find('input[name="addon_03"][data-sell="false"]');
    if ($frei.length === 1 && !$(this).find('input[name="addon_03"]:checked').length) {
      $frei.prop('checked', true);
      $(this).closest('.step').find('.confirmWok').removeClass('disabled');
    }
  });
  $('.confirmWok').each(function () { halongWokPreis($(this).closest('.popup')); });
}
$('.confirmWok').each(function () {
  var $btn = $(this);
  $btn.data('orig-html', $btn.html());
  $btn.data('basis-preis', halongEuro($btn.find('.confirmPrice').text()));
});
halongWokVorwahl();

$(document).on('change', 'input[name^="addon_"]', function () { halongWokPreis($(this).closest('.popup')); });
$(document).on('click', '.activePopup .plusButtonWok, .activePopup .MinusButtonWok', function () {
  var $popup = $(this).closest('.popup');
  setTimeout(function () { halongWokPreis($popup); }, 0);
});


  // Restaurant Halong 2026-10-09 (H-B): Knöpfe nur für den eigenen Schritt freigeben. Vorher gab eine Wahl in
  // Schritt 1 auch das „Weiter“ in Schritt 2 frei, und jede Wahl im Fenster gab „In den Warenkorb“ frei.
  $(document).on('change', '.popup input[type="radio"]', function () {
    window.halongKnopfStatus($(this).closest('.popup'));
  });

  // Navigation buttons
  jQuery(".next").on("click", function (e) {
    // Restaurant Halong 2026-10-09: verhindert das Absenden des Formulars (vorher im entfernten globalen Handler).
    e.preventDefault();
    const $currentStep = $(this).closest(".step");
    const $nextStep = $currentStep.next(".step");
    if ($nextStep.length && $currentStep.find('input[type=radio]:checked').length > 0){
      $currentStep.removeClass("active");
      $nextStep.addClass("active");
      window.halongKnopfStatus($currentStep.closest('.popup'));
    }else{
      window.halongPflichtHinweis(this, window.halongFehlendeWahl(this) || 'Bitte triff eine Auswahl.');
    }
  });

  jQuery(".prev").on("click", function (e) {
    e.preventDefault();
    const $currentStep = $(this).closest(".step");
    const $prevStep = $currentStep.prev(".step");

    if ($prevStep.length) {
      $currentStep.removeClass("active");
      $prevStep.addClass("active");
    }
  });

  
});
